import { Injectable, OnDestroy } from "@angular/core";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { NotificationResponse } from "../interfaces/responses/models";
import { WebsocketService } from "./websocket.service";

@Injectable({
  providedIn: "root",
})
export class NotificationService implements OnDestroy {
  private notificationUrlMap: { [key: string]: string } = {
    fixedRateBid: "fixed-rate-bid",
    strikePrice: "strike",
    allocation: "allocation",
    payment: "payment",
  };

  constructor(private websocketService: WebsocketService) {}

  ngOnDestroy(): void {
    this.disconnect();
  }

  public connect(): Observable<NotificationResponse> {
    console.log(`Connecting user notifications`);
    this.disconnect();

    this.websocketService.connectUser();

    return this.websocketService.userMessages$.pipe(
      map((data) => {
        const parsedData = data;

        if (
          parsedData &&
          parsedData.notification_type &&
          this.notificationUrlMap[parsedData.notification_type]
        ) {
          const urlSegment =
            this.notificationUrlMap[parsedData.notification_type];
          const notification: NotificationResponse = {
            message: parsedData.message,
            url: `${urlSegment}/${parsedData.link_id || ""}`,
            relatedBid: parsedData.link_id,
            type: parsedData.notification_type,
            reference: parsedData.reference,
          };
          console.log(
            "Notification processed from WebSocket: ",
            notification,
            " of type: ",
            parsedData.notification_type
          );
          return notification;
        } else {
          console.warn(
            "Received unknown message type from WebSocket:",
            parsedData
          );
          return null;
        }
      }),
      filter(
        (notification): notification is NotificationResponse =>
          notification !== null
      )
    );
  }

  public disconnect(): void {
    console.log("Disconnecting notifications (closing WebSocket via service)");
    this.websocketService.closeUserConnection();
  }
}
